import { createStandaloneToast, useToast } from '@chakra-ui/toast'
import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router'

const { ToastContainer } = createStandaloneToast()

// Automatically show success and error messages from the URL
export const CustomToastContainer = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const toast = useToast()
  const [successMessage, setSuccessMessage] = useState<string | null>(null)
  const [errorMessage, setErrorMessage] = useState<string | null>(null)

  useEffect(() => {
    setSuccessMessage((_) => searchParams.get('successMessage'))
    setErrorMessage((_) => searchParams.get('errorMessage'))
  }, [searchParams])

  const clearSuccessMessage = () => {
    setSuccessMessage(null)
    const newSearchParams = searchParams
    newSearchParams.delete('successMessage')
    setSearchParams(newSearchParams, { replace: true })
  }

  const clearErrorMessage = () => {
    setErrorMessage(null)
    const newSearchParams = searchParams
    newSearchParams.delete('errorMessage')
    setSearchParams(newSearchParams, { replace: true })
  }

  useEffect(() => {
    if (successMessage)
      toast({
        title: successMessage,
        status: 'success',
        duration: 5000,
        isClosable: true,
        onCloseComplete: () => clearSuccessMessage(),
      })
  }, [successMessage])

  useEffect(() => {
    if (errorMessage)
      toast({
        title: errorMessage,
        status: 'error',
        duration: 5000,
        isClosable: true,
        onCloseComplete: () => clearErrorMessage(),
      })
  }, [errorMessage])

  return <ToastContainer />
}
